import { IFundSearchState } from './types';

const state: IFundSearchState = {
  lookup: '',
  businessCode: '',
  numberOfFetching: 0,
  results: [],
  selectedResultIndex: -1,
  accessToken: '',
  fundSearchApiEndpoint: '',
  cacheSuffix: '',
  mustHaveCacheSuffix: false,
  lastFetchError: null,
};

export default state;
